import React from 'react'
import Highchart from '../Pages/Highchart'
import WeightChart from '../Pages/WeightChart'
import { Routes, Route } from 'react-router-dom'
import Nutrition from '../Pages/Nutrition'
import LifestylePyramid from '../Pages/LifestylePyramid'
import Glucose from '../Pages/Glucose'
import Agingpace from '../Pages/Agingpace'
import Safebar from '../Pages/Safebar'
import HealthJourney from '../Pages/HealthJourney'
import SleepScore from '../Pages/SleepScore'
import MyGoqii from '../Pages/MyGoqii'
import Stepgraph from '../Pages/Stepgraph'
import HealthTimeline from '../Pages/HealthTimeline'
import AgeCompare from '../Pages/AgeCompare'
import AgeGen from '../Pages/AgeGen'
import AllPages from '../Pages/AllPages'
import Agecard from '../Pages/Agecard'
import TaskPage from '../Pages/TasksPage'
import CycleTracker from '../Pages/CycleTracker'
import WomenOnboarding from '../Pages/WomenOnboarding'

import GoqiiCare from '../Pages/GoqiiCare'
import InsuranceCards from '../Pages/InsuranceCards'
import CorporateLeaderboardCard from '../Pages/CorporateLeaderboardCard'
import WomenLogs from '../Components/WomenLogs'
import GamesList from '../Pages/GamesList'
import CognitiveAge from '../Pages/CognitiveAge'
// import MemoryBlitz from '../Pages/Games/MemoryBlitz2'
import MemoryBlitz2 from '../Pages/Games/MemoryBlitz2'
import FlashRecall2 from '../Pages/Games/FlashRecall2'
import FocusFinder from '../Pages/Games/FocusFinder'
import ShapeShift from '../Pages/Games/ShapeShift'
import FocusTap2 from '../Pages/Games/FocusTap2'
import SignalScramble from '../Pages/Games/SignalScramble'
import MindMatch2 from '../Pages/Games/MindMatch2'
import FocusHold from '../Pages/Games/FocusHold'
import TrailJump2 from '../Pages/Games/TrailJump2'
import ChronoPulse2 from '../Pages/Games/ChronoPulse2'
import CaloriesCard from '../Pages/CaloriesCard'
import ResultPage from '../Components/Games/ResultPage'
import LifestyleCard from '../Pages/LifestyleCard'
import LifestyleGraphV2 from '../Pages/LifestyleGraphV2'
import HealthLocker from '../Pages/HealthLocker'
import HealthTest from '../Pages/HealthTest'
import MentalAssessment from '../Pages/MentalAssessment'
import SkinAssessment from '../Pages/SkinAssessment'
import AddictionAssessment from '../Pages/AddictionAssessment'
import NicotineDrugAssessment from '../Pages/NicotineDrugAssessment'
import AlcoholAssessment from '../Pages/AlcoholAssessment'
import CognitiveAssessment from '../Pages/CognitiveAssessment'
import GamesForGood from '../Pages/GamesForGood'
import AllGamesPlay from '../Pages/AllGamesPlay'
import UhtCashUsed from '../Pages/UhtCashUsed'
import NutritionInsights from '../Pages/NutritionInsights'
import LifestyleCardInfo from '../Pages/LifestyleCardInfo'
import ChallengeRulePage from '../Pages/ChallengeRulePage'
import MyCareTeam from '../Pages/MyCareTeam'
import FoodInfo from '../Pages/FoodInfo'
import FoodLogInsight from '../Pages/FoodLogInsight'
import DermaHomePage from '../Pages/DermaHomePage'
import SkinMood from '../Pages/SkinMood'
import SkinMoodEntry from '../Pages/SkinMoodEntry'
import ReportFlareUp from '../Pages/ReportFlareUp'
import EmotionalMoodToday from '../Pages/EmotionalMoodToday'
import PSQICalculator from '../Pages/PSQICalculator'
import EasiScore from '../Pages/EasiScore'
import EasiQ1 from '../Pages/EasiQ1'
import PasiScore from '../Pages/PasiScore'
import BodySurfaceArea from '../Pages/BodySurfaceArea'
import ReportFlareUpStats from '../Pages/ReportFlareUpStats'
import BsaDetails from '../Pages/BsaDetails'
import PsqiDermaDetails from '../Pages/PsqiDermaDetails'
import EasiDermaDetails from '../Pages/EasiDermaDetails'
import PasiDermaDetails from '../Pages/PasiDermaDetails'
import DlqiDetails from '../Pages/DlqiDetails'
import DlciQuestionaireOne from '../Pages/DlciQuestionaireOne'
import EmotionalWellbeing from '../Pages/EmotionalWellbeing'
import MoodTracking from '../Pages/MoodTracking'
import LogMedication from '../Pages/LogMedication'
import TreatmentPlan from '../Pages/TreatmentPlan'
import PSQIDetails from '../Pages/PSQIDetails'
import SelfStats from '../Pages/SelfStats'
import SelfStatsPfizer from '../Pages/SelfStatsPfizer'
import Medicate from '../Pages/Medicate'
import HomePageAdhd from '../Pages/HomePageAdhd'
import WFIRSS from '../Pages/WFIRSS'
import WFIRSSDetails from '../Pages/WFIRSSDetails'
import WfirsDetails from '../Pages/WfirsDetails'
import GOQiiSessions from '../Pages/GOQiiSessions'
import SessionsPlayer from '../Pages/SessionsPlayer'
import TermsAndPolicies from '../Pages/TermsAndPolicies'
import PrivacyPolicy from '../Pages/PrivacyPolicy'
import TermsOfServices from '../Pages/TermsOfServices'
import DownloadMonthlyPdf from '../Pages/DownloadMonthlyPdf'
import BannerPage from '../Pages/BannerPage'
import BodySurfaceAreaScorad from '../Pages/BodySurfaceAreaScorad'
import IntensityOfSign from '../Pages/IntensityOfSign'
import IntensityOfSymptoms from '../Pages/IntensityOfSymptoms'
import SCORADassessment from '../Pages/SCORADassessment'
import ScoradDetails from '../Pages/ScoradDetails'
import ScoradScore from '../Pages/ScoradScore'
import ScoradDashboard from '../Pages/ScoradDashboard'
import NHSEczemaProgram from '../Pages/NHSEczemaProgram'
import NHSEczemaProgramSummery from '../Pages/NHSEczemaProgramSummery'


export const AppRoute = () => {
  return (
    <Routes>

      <Route path="/userlifestyle/:uid" element={<AllPages />} />
      <Route path="/hra/:uid" element={<Highchart />} />
      <Route path="/weightzone/:uid" element={<WeightChart />} />
      <Route path="/food/:uid" element={<Nutrition />} />
      <Route path="/nutritioninsights/:uid" element={<NutritionInsights />} />
      <Route path="/lifestylepyramid/:uid" element={<LifestylePyramid />} />
      <Route path="/glucose/:uid" element={<Glucose />} />
      <Route path="/agingpace/:uid" element={<Agingpace />} />
      <Route path="/safebar/:uid" element={<Safebar />} />
      <Route path="/graph_v1/:uid" element={<HealthJourney />} />
      <Route path="/sleepscore/:uid" element={<SleepScore />} />
      <Route path="/lifestylecomparison/:uid" element={<MyGoqii />} />
      <Route path="/stepgraph/:uid" element={<Stepgraph />} />
      <Route path="/healthtimeline/:uid" element={<HealthTimeline />} />
      <Route path="/agecard/:uid" element={<Agecard />} />
      <Route path="/age_reversor_profile/:uid" element={<AgeCompare />} />
      <Route path="/age-reversor-gen/:uid" element={<AgeGen />} />
      <Route path="/tasks/:uid" element={<TaskPage type="dailyTasks" />} />
      <Route path="/weeklyprogress/:uid" element={<TaskPage type="weekProgress" />} />
      <Route path="/insurancecard/:uid" element={<InsuranceCards />} />
      <Route path="/goqiicare/:uid" element={<GoqiiCare />} />
      <Route path="/homecard_challenge/:uid" element={<CorporateLeaderboardCard />} />
      <Route path="/weekly-calories" element={<CaloriesCard />} />
      <Route path="/lifestylev2/:uid" element={<LifestyleCard />} />
      <Route path="/lifestyle_graph_compare/:uid" element={<LifestyleGraphV2 />} />
      <Route path='/cycletracker' element={<CycleTracker />} />
      <Route path='/goal-new' element={<CycleTracker />} />
      <Route path='/women-cycle' element={<WomenOnboarding />} />
      <Route path='/health_locker' element={<HealthLocker />} />
      <Route path='/health_test' element={<HealthTest />} />
      <Route path='/health_assessment' element={<MentalAssessment />} />
      <Route path='/skin_assessment' element={<SkinAssessment />} />
      <Route path='/addiction_assessment' element={<AddictionAssessment />} />
      <Route path='/nicotinedrug_assessment' element={<NicotineDrugAssessment />} />
      <Route path='/alchohol_assessment' element={<AlcoholAssessment />} />
      <Route path='/cognitive_assessment' element={<CognitiveAssessment />} />
      <Route path='/cognitive-assessment-home' element={<CognitiveAssessment />} />
      <Route path='/games-4-good' element={<GamesForGood />} />
      <Route path='/all-games-play' element={<AllGamesPlay />} />
      <Route path='/uht-cash-used' element={<UhtCashUsed />} />
      <Route path='/lifestylecardinfo' element={<LifestyleCardInfo />} />
      <Route path='/rules' element={<ChallengeRulePage />} />
      <Route path='/log' element={<WomenLogs />} />
      <Route path='/mct' element={<MyCareTeam />} />
      <Route path='/food-info' element={<FoodInfo />} />
      <Route path='/foodlog_insight' element={<FoodLogInsight />} />
      <Route path='/homepage' element={<DermaHomePage />} />
      <Route path='/skin-mood' element={<SkinMood />} />
      <Route path='/skinmoodentry' element={<SkinMoodEntry />} />
      <Route path='/report-flare-up' element={<ReportFlareUp />} />
      <Route path='/emotional-mood-today' element={<EmotionalMoodToday />} />
      <Route path='/psqi-calculator' element={<PSQICalculator />} />
      <Route path='/easi-score' element={<EasiScore />} />
      <Route path='/easifirst' element={<EasiQ1 />} />
      <Route path='/pasi-score' element={<PasiScore />} />
      <Route path='/body-surface-area' element={<BodySurfaceArea />} />
      <Route path='/report-flare-stats' element={<ReportFlareUpStats />} />
      <Route path='/bsadetails' element={<BsaDetails />} />
      <Route path='/psqidermadetails' element={<PsqiDermaDetails />} />
      <Route path='/easidermadetails' element={<EasiDermaDetails />} />
      <Route path='/pasidermadetails' element={<PasiDermaDetails />} />
      <Route path='/dlqidetails' element={<DlqiDetails />} />
      <Route path='/dlciquestionaireone' element={<DlciQuestionaireOne />} />

      {/* Derma / NHS migrated routes */}
      <Route path='/emotional-wellbeing' element={<EmotionalWellbeing />} />
      <Route path='/mood-tracking' element={<MoodTracking />} />
      <Route path='/log-medication' element={<LogMedication />} />
      <Route path='/treatment-plan' element={<TreatmentPlan />} />
      <Route path='/psqi-details' element={<PSQIDetails />} />
      <Route path='/self-stats' element={<SelfStats />} />
      <Route path='/selfstatspfizer' element={<SelfStatsPfizer />} />
      <Route path='/skin/:userId' element={<Medicate />} />
      <Route path='/homepageadhd' element={<HomePageAdhd />} />
      <Route path='/wfirs-s' element={<WFIRSS />} />
      <Route path='/wfirs-details' element={<WFIRSSDetails />} />
      <Route path='/wfirsdetails' element={<WfirsDetails />} />
      <Route path='/goqii-sessions' element={<GOQiiSessions />} />
      <Route path='/sessions-player' element={<SessionsPlayer />} />
      <Route path='/terms-and-policies' element={<TermsAndPolicies />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/terms-of-services' element={<TermsOfServices />} />
      <Route path='/monthlyreport' element={<DownloadMonthlyPdf />} />
      <Route path='/banner' element={<BannerPage />} />
      <Route path='/scorad-bsa' element={<BodySurfaceAreaScorad />} />
      <Route path='/scorad-intensity' element={<IntensityOfSign />} />
      <Route path='/scorad-intensity-symptoms' element={<IntensityOfSymptoms />} />
      <Route path='/scorad-assessment' element={<SCORADassessment />} />
      <Route path='/scorad-details' element={<ScoradDetails />} />
      <Route path='/scorad-score' element={<ScoradScore />} />
      <Route path='/scorad-dashboard' element={<ScoradDashboard />} />
      <Route path='/nhs-eczema-program' element={<NHSEczemaProgram />} />
      <Route path='/nhs-eczema-program-summery' element={<NHSEczemaProgramSummery />} />

{/* Games pages */}
      <Route path="/memoryblitz/:uid" element={<MemoryBlitz2 />} />
      <Route path="/focusfinder/:uid" element={<FocusFinder />} />
      <Route path="/flashrecall/:uid" element={<FlashRecall2 />} />
      <Route path="/focustap/:uid" element={<FocusTap2 />} />
      <Route path="/shapeshift/:uid" element={<ShapeShift />} />
      <Route path="/signalscramble/:uid" element={<SignalScramble />} />
      <Route path="/games/:uid" element={<GamesList />} />
      <Route path="/games" element={<GamesList />} />
      <Route path="/cognitive-age/:uid" element={<CognitiveAge />} />
      <Route path="/cognitive-age" element={<CognitiveAge />} />
      <Route path="/mindmatch/:uid" element={<MindMatch2 />} />
      <Route path="focushold/:uid" element={<FocusHold />} />
      <Route path="/trailjump/:uid" element={<TrailJump2 />} />
      <Route path="/chronopluse/:uid" element={<ChronoPulse2 />} />
      <Route path='/result' element={<ResultPage/>} />
    </Routes>
  )
}

export default AppRoute;
